import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FilterPanel = ({ filters, onFilterChange, onResetFilters, selectedCount, onShowComparison }) => {
  const regionOptions = [
    { value: 'all', label: 'Toutes les régions' },
    { value: 'Dakar', label: 'Dakar' },
    { value: 'Thiès', label: 'Thiès' },
    { value: 'Saint-Louis', label: 'Saint-Louis' },
    { value: 'Diourbel', label: 'Diourbel' },
    { value: 'Kaolack', label: 'Kaolack' },
    { value: 'Ziguinchor', label: 'Ziguinchor' },
    { value: 'Louga', label: 'Louga' }
  ];

  const studyFieldOptions = [
    { value: 'all', label: 'Tous les domaines' },
    { value: 'sciences', label: 'Sciences et Technologies' },
    { value: 'business', label: 'Commerce et Gestion' },
    { value: 'health', label: 'Santé et Médecine' },
    { value: 'humanities', label: 'Sciences Humaines' },
    { value: 'arts', label: 'Arts et Créativité' },
    { value: 'agriculture', label: 'Agriculture et Environnement' }
  ];

  const institutionTypeOptions = [
    { value: 'all', label: 'Tous les types' },
    { value: 'public', label: 'Public' },
    { value: 'private', label: 'Privé' }
  ];

  const programLevelOptions = [
    { value: 'all', label: 'Tous les niveaux' },
    { value: 'licence', label: 'Licence (BAC+3)' },
    { value: 'master', label: 'Master (BAC+5)' },
    { value: 'doctorat', label: 'Doctorat (BAC+8)' },
    { value: 'ingenieur', label: 'Ingénieur (BAC+5)' },
    { value: 'mba', label: 'MBA' }
  ];

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4 md:p-6 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-4">
        <h2 className="text-lg md:text-xl font-semibold text-gray-800 flex items-center gap-2">
          <Icon name="SlidersHorizontal" size={24} color="var(--color-primary)" />
          Filtres de Recherche
        </h2>
        {selectedCount > 0 && (
          <div className="flex items-center gap-2 bg-blue-50 text-blue-700 px-4 py-2 rounded-lg">
            <Icon name="CheckSquare" size={20} />
            <span className="text-sm font-medium">{selectedCount} école(s) sélectionnée(s)</span>
          </div>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        <Select
          label="Région"
          options={regionOptions}
          value={filters?.region}
          onChange={(value) => onFilterChange('region', value)}
          placeholder="Sélectionner une région"
        />

        <Select
          label="Domaine d'études"
          options={studyFieldOptions}
          value={filters?.studyField}
          onChange={(value) => onFilterChange('studyField', value)}
          placeholder="Sélectionner un domaine"
        />

        <Select
          label="Type d'établissement"
          options={institutionTypeOptions}
          value={filters?.institutionType}
          onChange={(value) => onFilterChange('institutionType', value)}
          placeholder="Sélectionner un type"
        />

        <Select
          label="Niveau de programme"
          options={programLevelOptions}
          value={filters?.programLevel}
          onChange={(value) => onFilterChange('programLevel', value)}
          placeholder="Sélectionner un niveau"
        />
      </div>
      <div className="flex flex-col sm:flex-row gap-3">
        <Button
          variant="outline"
          iconName="RotateCcw"
          iconPosition="left"
          onClick={onResetFilters}
          className="flex-1 sm:flex-initial"
        >
          Réinitialiser
        </Button>
        {selectedCount >= 2 && (
          <Button
            variant="default"
            iconName="GitCompare"
            iconPosition="left"
            onClick={onShowComparison}
            className="flex-1 sm:flex-initial"
          >
            Comparer ({selectedCount})
          </Button>
        )}
      </div>
    </div>
  );
};

export default FilterPanel;